module.exports = __webpack_public_path__ + "assets/img/4_86.b74c5383.jpg";